








































import { Vue, Component, Prop, Watch, } from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency.js";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import moment from "moment";
import { Validator } from "vee-validate";
import { ReimbursementRequest } from "@/shared/types";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useBankAccountStore } from "../store/bankAccount";
import { useReimburseMeStore } from "@/employee/store/reimburseMe";

@Component({
  components: {
    RadioButton,
    Button
  }
})
export default class ReimburseMeForm extends Vue {
  hsaDailyBalanceStore = useHsaDailyBalanceStore();
  bankAccountStore = useBankAccountStore();
  reimburseMeStore = useReimburseMeStore();

  $validator: Validator;
  isSubmitting = false;

  @Prop()
  prefill: number;

  @Prop()
  expenseIds: number [];

  @Prop()
  onSubmit: () => void;

  formatCurrency = formatCurrency;
  formHasError = false;
  money = {
    decimal: ".",
    thousands: ",",
    prefix: "$",
    suffix: "",
    precision: 2,
    masked: false
  };
  checkedRadio = null;
  amount = this!.prefill || 0;
  selectedLinkedBankAccount = 0;

  mounted () {
    this.hsaDailyBalanceStore.setCurrentEndDateKey(moment().format("YYYYMMDD"));
    this.hsaDailyBalanceStore.loadPredictedDailyBalances();
    this.hsaDailyBalanceStore.loadBalanceOnFile();
    this.bankAccountStore.loadLinkedBankAccounts();
    this.bankAccountStore.getBankAccountStatus();
    this.updateLinkedBankAccount();
  }

  @Watch("prefill")
  setReimburseAmount () {
    if (this.prefill) {
      this.amount = Math.round(this.prefill * 100) / 100;
    }
  }

  @Watch("hasLinkedAccounts")
  @Watch("hasOnlyOneAccount")
  onHasLinkedAccounts () {
    this.updateLinkedBankAccount();
  }

  onSubmitReimburse () {
    if (this.isSubmitting) {
      return;
    }

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;
      const request: ReimbursementRequest = {
        amount: this.amount,
        reimbursementLinkedAccountId: this.selectedLinkedBankAccount,
        expenseIds: this.expenseIds
      };
      this.reimburseMeStore.reimburse(request).then(resp => {
        if (this.onSubmit) {
          this.onSubmit();
        }
        this.isSubmitting = false;
        this.amount = 0;
        this.$validator.reset();
        this.reimburseMeStore.reloadPage();
      });
    });
  }

  get validateReimburseAmount () {
      return {
        required: true,
        decimal: 2,
        min_value_usd: 1,
        max_value_usd: this.availableCashAmount
    };
  }

  get availableCashAmount (): number {
    return this.hsaDailyBalanceStore.getInstantBalance.amount || this.hsaDailyBalanceStore.balanceOnFileAmount;
  }

  onOptionChange (selected) {
    this.checkedRadio = selected;
  }

  isCashBalanceLoaded () {
    return this.hsaDailyBalanceStore.balanceOnFileLoaded;
  }

  getButtonText () {
    if (this.formHasError || this.amount <= 0) {
      return "Reimburse me";
    }
    return "Reimburse me " + formatCurrency(this.amount);
  }

  get isSubmitDisabled () {

    if (this.bankAccountStore.isBankAccountClosed) {
      return true;
    }

    return this.$validator.errors.any() || this.isSubmitting || this.amount <= 0
    || this.amount > this.availableCashAmount;
  }

  get insufficientFunds () {
    return this.availableCashAmount <= 0;
  }

  get inputClasses () {
    return this.formHasError ? "amount-input form-control amount-input__error" : "amount-input form-control";
  }
  get hasLinkedAccounts () {
    return this.bankAccountStore.verifiedLinkedAccounts && this.bankAccountStore.verifiedLinkedAccounts.length > 0;
  }
  get hasOnlyOneAccount () {
    return this.bankAccountStore.verifiedLinkedAccounts && this.bankAccountStore.verifiedLinkedAccounts.length === 1;
  }
  get linkedBankAccounts () {
    return this.bankAccountStore.verifiedLinkedAccounts;
  }
  updateLinkedBankAccount () {
    if (this.hasOnlyOneAccount) {
      this.selectedLinkedBankAccount = this.bankAccountStore.verifiedLinkedAccounts[0].linkedBankAccountId;
    } else if (this.bankAccountStore.defaultReimbursementAccount && this.selectedLinkedBankAccount === 0) {
      this.selectedLinkedBankAccount = this.bankAccountStore.defaultReimbursementAccount.linkedBankAccountId;
    }
  }
}
